import apis from '../utils/apis';

export interface StaticRolePermission {
  id: number;
  role_name: string;
  display_name: string;
  org_type: string;
  permissions: string[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface StaticListResponse<T> {
  success: boolean;
  list_name?: string;
  data?: T[];
  count?: number;
  error?: string;
}

export interface AvailableListsResponse {
  success: boolean;
  lists?: Record<string, string>;
  error?: string;
}

class StaticListsService {
  static async getAvailableLists(): Promise<AvailableListsResponse> {
    try {
      const response = await apis.get('/api/static-lists');
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  static async getStaticList<T>(
    listName: string,
    filters?: Record<string, any>
  ): Promise<StaticListResponse<T>> {
    try {
      let url = `/api/static-lists/${listName}`;

      if (filters && Object.keys(filters).length > 0) {
        const queryParams = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== null && value !== undefined) {
            queryParams.append(key, String(value));
          }
        });
        url += `?${queryParams.toString()}`;
      }

      const response = await apis.get(url);
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  static async getRolePermissions(
    orgType: string,
    activeOnly: boolean = true
  ): Promise<StaticRolePermission[]> {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('org_type', orgType);
      queryParams.append('active_only', String(activeOnly));

      const response = await apis.get(`/role-permissions/list?${queryParams.toString()}`);

      if (response.data.success && response.data.data) {
        // Parse permissions string to array if needed
        return response.data.data.map((role: any) => ({
          ...role,
          permissions: typeof role.permissions === 'string'
            ? JSON.parse(role.permissions)
            : role.permissions,
        }));
      }
      return [];
    } catch (error: any) {
      throw error;
    }
  }

  static async getRolePermissionById(roleId: number): Promise<StaticRolePermission | null> {
    try {
      const response = await apis.get(`/role-permissions/${roleId}`);

      if (response.data.success && response.data.data) {
        return response.data.data;
      }
      return null;
    } catch (error: any) {
      throw error;
    }
  }
}

export default StaticListsService;
